import React, { useState } from 'react'
import useReportServices from '../hooks/useReportServices'
import FullSizeLayout from '../../../../../../generic/Layouts/FullSizeLayout'
import ControlSearchPannelLayout from '../../../../../../generic/Layouts/Wrappers/ControlSearchPannelLayout'
import SearchInput from '../../../../../../generic/inputs/inputSearch'
import DatePickerISO from '../../../forcasts/Distribution/Components/DatePickerISO'
import DatePickerRangeISO from '../../../knisotLines/Components/DatePickerRangeISO'
import Table from '../../../procedures/Q8/Layouts/Table/Table'
import ReportTableHead from './ReportTableHead'
import ColumModal from '../../../../../../generic/Layouts/ColumModal'
import ReportFilterModal from './ReportFilterModal'
import CircleActiveFilterBtn from '../../../../../../generic/particles/CircleActiveFilterBtn'
import FilterIcon from '../../../../../../generic/icons/IconLib/FilterIcon'
import ReportTableBody from './ReportTableBody'


const Reports = () => {
  const {
    dashboardData,
   
    search,
    setSearch,
    isOpenFilterModal,
    handleModalFilter,
    date,
    setDate,
    selectedSeller,
    setSelectedSeller,
    selectedProblemType,
    setSelectedProblemType,
    selectedCustomer,
    setSelectedCustomer,
    selectedGroupBy,
    setSelectedGroupBy,
    selectedProduct,
    setSelectedProduct,
    sellerList,
    handleGetReports,
    problemTypeList,
    customerList,
    productList,
    isAllowToFetchForReports,
  } = useReportServices()

  return (
    <FullSizeLayout
      label='דוח זיכויים'
    >
      {
        isOpenFilterModal &&
        <ColumModal 
          title='הגדרות סינון'
          controlFunc={handleModalFilter}
          Children={ReportFilterModal}
          childrenProps={{
            date,
            setDate,
            handleGetReports,
            selectedSeller,
            setSelectedSeller,
            selectedProblemType,
            setSelectedProblemType,
            selectedCustomer,
            setSelectedCustomer,
            selectedGroupBy,
            setSelectedGroupBy,
            selectedProduct,
            setSelectedProduct,
            sellerList,
            problemTypeList,
            customerList,
            productList,
            handleModalFilter,
            isAllowToFetchForReports,
          }}
        />
      }
      <ControlSearchPannelLayout>
        <SearchInput
          input={search}
          setInput={setSearch}
        />
        
        <CircleActiveFilterBtn
          func={handleModalFilter}
        >
          <FilterIcon />
        </CircleActiveFilterBtn>
      </ControlSearchPannelLayout>
      {
        dashboardData &&
        <Table>
          <ReportTableHead
            meta={dashboardData.MetaData}
          />
          <ReportTableBody
            data={dashboardData.Data}
          />
        </Table>
      }
    </FullSizeLayout>
  )
}

export default Reports